import React, { useState } from "react";
import { Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { BasicModal } from "../../../Shared";
import { Syllabu } from "../../../../api";
import { useAuth, usePermissions } from "../../../../hooks";
import { SyllabuForm } from "../SyllabuForm";
import { SyllabuSubjectGradeForm } from "../SyllabuSubjectGradeForm";
import "./SyllabuItem.scss";

const syllabuController = new Syllabu();

export function SyllabuItem(props) {
  const { syllabu, onReload } = props;
  const { accessToken } = useAuth();
  const { hasPermission } = usePermissions();

  const canUpdate = hasPermission("syllabu", "update");
  const canDelete = hasPermission("syllabu", "delete");

  const [showModal, setShowModal] = useState(false);
  const [showModalSubject, setShowModalSubject] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseModalSubject = () =>
    setShowModalSubject((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openSubjectManagement = () => {
    setTitleModal(`Gestionar asignaturas de malla curricular: ${syllabu.name}`);
    onOpenCloseModalSubject();
  };

  const openUpdateSyllabu = () => {
    setTitleModal(`Actualizar malla curricular: ${syllabu.name}`);
    onOpenCloseModal();
  };

  const openDeleteConfirm = () => {
    setConfirmMessage(`¿Eliminar la malla curricular ${syllabu.name}?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await syllabuController.deleteSyllabu(accessToken, syllabu.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="syllabu-item">
        <div className="syllabu-item__info">
          <span className="syllabu-item__info-name">{syllabu.name}</span>
        </div>
        <div>
          {canUpdate && (
            <Popup
              content="Gestionar asignaturas"
              trigger={
                <Button icon color="orange" onClick={openSubjectManagement}>
                  <Icon name="plus" />
                </Button>
              }
            />
          )}
          <Popup
            content="Contenido multimedia"
            trigger={
              <Button
                icon
                color="green"
                as={Link}
                to={`/admin/media/${syllabu.id}`}
              >
                <Icon name="book" />
              </Button>
            }
          />
          {canUpdate && (
            <Popup
              content="Actualizar malla curricular"
              trigger={
                <Button icon primary onClick={openUpdateSyllabu}>
                  <Icon name="pencil" />
                </Button>
              }
            />
          )}
          {canDelete && (
            <Popup
              content="Eliminar malla curricular"
              trigger={
                <Button icon color="red" onClick={openDeleteConfirm}>
                  <Icon name="trash" />
                </Button>
              }
            />
          )}
        </div>
      </div>
      <BasicModal
        size={"large"}
        scrolling={false}
        show={showModalSubject}
        close={onOpenCloseModalSubject}
        title={titleModal}
      >
        <SyllabuSubjectGradeForm
          onClose={onOpenCloseModalSubject}
          syllabu={syllabu}
        />
      </BasicModal>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <SyllabuForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          syllabu={syllabu}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
